var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function subscribeAll(conn, store) {
    store.getAllQueries().forEach(q => {
        conn.send(JSON.parse(q));
    });
}
export function connectWithSubscriptions(conn, store, url) {
    return __awaiter(this, void 0, void 0, function* () {
        if (store.getAllQueries().length > 0) {
            const x = yield conn.connect(url);
            subscribeAll(conn, store);
            return x;
        }
        return conn.isConnected();
    });
}
//# sourceMappingURL=ConnectWithSubscriptions.js.map